export default class MemberListController {
  constructor($stateParams, Member) {
    'ngInject';

    this.$stateParams = $stateParams;
    this.Member = Member;
  }

  $onInit() {
    const letter = this.$stateParams.letter || 'a';

    this.members = [];
    this.searchParams = {
      letter,
      page: 1,
    }

    this.loadMembers(this.searchParams);
  }

  loadMore() {
    this.searchParams.page += 1;
    this.loadMembers(this.searchParams);
  }

  loadMembers(searchParams = {}) {
    this.loading = true;
    return this.Member.query(searchParams).$promise
      .then((response) => {
        this.lastResponse = response.members;
        this.members.push(...response.members);
        this.loading = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/members/screens/member-list/member-list.controller.js